// extracted by mini-css-extract-plugin
export default {"wrapper":"QB-z","viewport":"RB-z","container":"SB-z","slide":"TB-z"};